import { Image } from '@optimus-web/core';
import { withMewsSrcSet } from '../Hoc';
import { MewsImageProps } from '../Hoc/MewsImageProps';

export const MewsImage = (props: MewsImageProps) => withMewsSrcSet(Image)(props);
